import type { QueryClient } from "@tanstack/react-query";

// Todas las queries que leen de pest_scouting_sessions (y, con los focos, de
// pest_foci). Es el espejo de `treatmentDataInvalidation.ts`, y nace del mismo
// fallo: cada pantalla invalidaba su puñado de claves a mano. Clasificar un
// parte en el panel de triaje solo refrescaba el mapa, así que la tarjeta del
// panel, la bandeja de alertas, el recuento de plagas activas y los informes
// seguían enseñando lo de antes hasta el staleTime o un remontaje. Con los
// focos sería peor: un enlace cambia a la vez el mapa, la ficha del foco, las
// alertas y los informes.
//
// Prefijos: invalidateQueries hace match parcial por prefijo.
//
// `scouting-sessions` no la consume nadie hoy (la lista de Plagas carga a mano,
// sin React Query), pero varias pantallas la invalidan: se conserva para que
// quien migre esa lista no tenga que redescubrirla.
export const SCOUTING_DATA_QUERY_KEYS: string[] = [
  // Mapa de sanidad y sus fichas
  "farm-health-map",
  "focus-session",
  "session-focus",
  "focus-sheet",
  "focus-link-candidates",
  "line-followup",
  // Trabajador
  "worker-scouting-sessions",
  // Panel y alertas
  "pest-alerts",
  "dismissed-alerts",
  "worker-quick-reports-pending",
  "active-pest-count",
  "blocks-with-active-pest",
  "greenhouse-health",
  "splash-bento-active-pests",
  // Lista de Plagas
  "scouting-sessions",
  // Analíticas
  "pests-by-block-triage",
  "top-pests-by-triage",
  "pest-pressure-trend",
  "alerts-severity-from-sessions",
  // Informes
  "reports-v3-plagas",
  "reports-v3-campanas",
];

/**
 * Invalida todo lo que depende de los partes de plaga y de sus focos. Llamar
 * tras crear, clasificar, descartar, resolver, reabrir, enlazar o borrar un
 * parte — y tras cualquier acción sobre un foco.
 */
export function invalidateScoutingData(queryClient: QueryClient) {
  for (const key of SCOUTING_DATA_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
